import { supabase } from '../supabase';

// TS mirrors of the SQL helpers is_keystone_member / is_keystone_leader.
// Calling the SQL functions via RPC keeps the source of truth in the database
// and avoids drift between the RLS gate and the UI gate.

export async function isKeystoneMember(userId: string): Promise<boolean> {
  const { data, error } = await supabase.rpc('is_keystone_member', { uid: userId });
  if (error) {
    console.error('isKeystoneMember check failed:', error);
    return false;
  }
  return Boolean(data);
}

export async function isKeystoneLeader(userId: string): Promise<boolean> {
  const { data, error } = await supabase.rpc('is_keystone_leader', { uid: userId });
  if (error) {
    console.error('isKeystoneLeader check failed:', error);
    return false;
  }
  return Boolean(data);
}
